import { useState } from 'react';
import ChartContext from './ChartContext'

const ChartState = ({ children }) => {

    const [hoveredValue, setHoveredValue] = useState(null);


    const chartValues = {
        hoveredValue,
        setHoveredValue
    };
    return (
        <ChartContext.Provider value={chartValues}>
            {children}
        </ChartContext.Provider>
    )
}

export default ChartState
